var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "introduction-contact area"
  }, [_vm._m(0), _c("section", {
    staticClass: "introduction-contact__city"
  }, [_c("a-row", {
    attrs: {
      gutter: [24, 32]
    }
  }, _vm._l(_vm.contactList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 12
      }
    }, [_c("contact-card", _vm._b({}, "contact-card", item, false))], 1);
  }), 1)], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "introduction-contact__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CONTACT")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("联系我们")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };